import { styles } from './CarouselLeadImage.css';
import React, { ReactNode } from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ProductCarousel, ProductCarouselProps } from '../ProductCarousel/ProductCarousel';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';
import { Icon, IconName } from '@jbhi-fi/lanyard-ui/components/Icon';
import { formatDate } from '../ProductHtmlBanner/utils';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export type CarouselLeadImageProps = {
  desktopImage?: ReactNode;
  mobileImage?: ReactNode;
  linkProps?: GoToLinkProps;
  ctaButton?: ReactNode;
  heading: string;
  subText?: string;
  isWhiteSubText?: boolean;
  productCarouselProps: ProductCarouselProps;
  shouldHideHeadingOnMobile?: boolean;
  brandLogo?: IconName;
  endDate?: string;
};

export const CarouselLeadImage = ({
  desktopImage,
  mobileImage,
  linkProps,
  ctaButton,
  heading,
  subText,
  isWhiteSubText,
  productCarouselProps,
  shouldHideHeadingOnMobile,
  brandLogo,
  endDate,
}: CarouselLeadImageProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const shouldShowCtaInLeadContent = !!desktopImage || !!brandLogo;
  const hasRelevantImage = isDesktop ? !!desktopImage : !!mobileImage;
  return (
    <div className={styles.wrapper}>
      {linkProps && isDesktop ? <GoToLink {...linkProps} className={styles.link} /> : null}
      <div className={styles.container({ hasImage: hasRelevantImage, hasBrandLogo: !!brandLogo })}>
        {hasRelevantImage ? (
          <div className={styles.imageContainer}>{isDesktop ? desktopImage : mobileImage}</div>
        ) : null}
        {shouldHideHeadingOnMobile && !isDesktop ? null : (
          <div className={styles.leadContainer({ hasImage: hasRelevantImage })}>
            {brandLogo ? (
              <Icon name={brandLogo} className={styles.brandLogo} preserveAspectRatio="xMinYMid meet" />
            ) : null}
            <CalloutFont as="h1" className={styles.headingText({ hasImage: hasRelevantImage })}>
              {heading}
            </CalloutFont>
            {endDate ? (
              <CalloutFont as="span" className={styles.endDate}>
                ENDS {formatDate(new Date(endDate))}
              </CalloutFont>
            ) : null}
            {subText ? <p className={styles.subText({ isWhiteSubText })}>{subText}</p> : null}
            {isDesktop && ctaButton && shouldShowCtaInLeadContent ? <div className={styles.ctaButton}>{ctaButton}</div> : null}
          </div>
        )}
        <div className={styles.carouselContainer}>
          <ProductCarousel {...productCarouselProps} />
        </div>
      </div>
      {ctaButton && (!isDesktop || !shouldShowCtaInLeadContent) ? (
        <div className={styles.bottomCtaButton}>{ctaButton}</div>
      ) : null}
    </div>
  );
};
